var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"register__container"},[(_vm.currentStep)?_c('registration-progress-steps',{attrs:{"currentStep":_vm.currentStep}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }